import { Routes, Route } from "react-router-dom";
import HelpCenterHome from "src/components/HelpCenter/helpCenterHome.jsx";
import HelpCenterSearchPage from "src/components/HelpCenter/helpCenterSearchPage.jsx";
import HelpCenterRolePage from "src/components/HelpCenter/helpCenterRolePage.jsx";
import HelpCenterArticleDetails from "src/components/HelpCenter/helpCenterArticleDetails";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setHelpCenterArticles } from "src/store/slices/helpCenterSlice";
import { getArticlesForSearch } from "src/api/helpCenter";

export default function HelpCenter() {
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const articles = await getArticlesForSearch();
        dispatch(setHelpCenterArticles(articles));
      } catch (error) {
        console.error("Error fetching help center articles:", error);
      }
    };

    fetchArticles();
  }, [dispatch]);

  return (
    <Routes>
      <Route path="/" element={<HelpCenterHome />} />
      <Route path="/search" element={<HelpCenterSearchPage />} />
      <Route path="/by-role" element={<HelpCenterRolePage />} />
      <Route path="/:articleId" element={<HelpCenterArticleDetails />} />
    </Routes>
  );
}
